import { gql } from '@apollo/client';

export const RETURN_INSPECTION_QUEUE = gql`
  query ReturnInspectionQueue($input: ReturnInspectionQueueInput!) {
    returnInspectionQueue(input: $input) {
      storeId
      totalCount
      limit
      offset
      hasMore
      nodes {
        id
        returnId
        storeId
        orderId
        status
        returnNumber
        orderNumber
        customerName
        customerEmail
        trackingNumber
        carrier
        trackingUrl
        deliveredAt
        triggerReasons
        items {
          id
          orderItemId
          title
          sku
          quantity
          reason
        }
        openedAt
        updatedAt
        closedAt
        reviewerId
        decision
        warehouseRequestedAt
        warehouseNotes
        returnUpdatedAt
      }
    }
  }
`;

export const REQUEST_RETURN_WAREHOUSE_CONFIRMATION = gql`
  mutation RequestReturnWarehouseConfirmation(
    $input: RequestReturnWarehouseConfirmationInput!
  ) {
    requestReturnWarehouseConfirmation(input: $input) {
      id
      returnId
      status
      warehouseRequestedAt
      warehouseNotes
      returnUpdatedAt
    }
  }
`;
